import { render, staticRenderFns } from "./CreateCompletion.vue?vue&type=template&id=46ab56e1&scoped=true"
import script from "./CreateCompletion.vue?vue&type=script&lang=js"
export * from "./CreateCompletion.vue?vue&type=script&lang=js"
import style0 from "./CreateCompletion.vue?vue&type=style&index=0&id=46ab56e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab56e1",
  null
  
)

export default component.exports